import { Component, OnInit, Input, ViewChild, HostListener, SimpleChanges } from '@angular/core';
import { DashboardService } from '../../services/dashboard/dashboard.service';
import { DashboardLocalService } from "../../services/dashboard/dashboard-local.service";
import { DashboardViewComponent } from '../dashboard-view/dashboard-view.component';
import { InboxService } from '../../services/inbox.service';
import { UserDataService } from '../../services/user-data.service';
import { FadingDialogComponent } from '../../dashboard/fading-dialog/fading-dialog.component';

import * as Highcharts from 'highcharts';

import Exporting from 'highcharts/modules/exporting';
import OfflineExporting from 'highcharts/modules/offline-exporting';
import ExportData from 'highcharts/modules/export-data';
import CustomEvents from 'highcharts-custom-events';

function applyHighchartsModule(module, Highcharts) {
  if (typeof module === 'function') {
    module(Highcharts);
  } else if (module && typeof module.default === 'function') {
    module.default(Highcharts);
  }
}

applyHighchartsModule(Exporting, Highcharts);
applyHighchartsModule(OfflineExporting, Highcharts);
applyHighchartsModule(ExportData, Highcharts);
applyHighchartsModule(CustomEvents, Highcharts);


import $ from 'jquery';
import { PiwikProUtils } from '../../common/utility/piwikProUtils';

@Component({
  selector: 'app-inquiries-by-assigned-group',
  templateUrl: './inquiries-by-assigned-group.component.html',
  styleUrls: ['./inquiries-by-assigned-group.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  },

})
export class InquiriesByAssignedGroupComponent implements OnInit {

  constructor(private DS: DashboardService, private localService: DashboardLocalService, private inboxService: InboxService,
    private parentComponent: DashboardViewComponent, private userDataService: UserDataService) {
    this.options.ngComponent = this;
  }
  protected chartWidth;
  protected chartHeight;
  rootNode: any;
  Highcharts = Highcharts; // required
  showbyAge = true;
  @Input() category: any;
  @Input() iData: any;
  prevEvent: any = "";
  selectedGroup = "";
  protected fullScreen = false;
  protected isRedrawInProgress = false;
  @ViewChild(FadingDialogComponent, { static: true }) fadingDialogComponent;
  groupData: any;

  // for legend hover
  protected initializeLegendHoverEffects() {
    const style = document.createElement('style');
    style.innerHTML = `
      .legendLabel {
        cursor: pointer;
      }
      .legendLabel:hover .hover-icon {
        display: inline-block !important;
      }
      .hover-icon {
        cursor: pointer;
        position: absolute;
        z-index: 10;
      }
      /* Add specific style for the SVG paths to ensure they're blue */
      .hover-icon svg path {
        fill: #0066CC;
      }
      
      /* Remove the standard tooltip */
      .hover-icon:hover::after {
        display: none;
      }
      
      /* Add a custom tooltip class that will be created dynamically */
      .custom-hover-tooltip {
        position: fixed;
        background-color: white;
        color: #333;
        padding: 4px 8px;
        border-radius: 4px;
        font-size: 12px;
        white-space: nowrap;
        box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
        font-family: 'OpenSans', sans-serif;
        z-index: 9999;
        pointer-events: none;
      }
    `;
    document.head.appendChild(style);
    
    setTimeout(() => {
      this.initializeHoverIconEvents();
    }, 500); // Short delay to ensure DOM is ready
  }
  
  // Add this new method to handle tooltip events
  protected initializeHoverIconEvents() {
    // Find all hover icons
    const hoverIcons = document.querySelectorAll('.hover-icon');
    
    // Remove any existing tooltip
    const removeTooltip = () => {
      const existingTooltip = document.querySelector('.custom-hover-tooltip');
      if (existingTooltip) {
        existingTooltip.remove();
      }
    };
    
    // Add mouse events to each icon
    hoverIcons.forEach(icon => {
      // Remove existing event listeners first to prevent duplicates
      const newIcon = icon.cloneNode(true);
      if (icon.parentNode) {
        icon.parentNode.replaceChild(newIcon, icon);
      }
      
      newIcon.addEventListener('mouseenter', (event: MouseEvent) => {
        removeTooltip(); // Remove any existing tooltip
        
        // Fix TypeScript error by properly casting event.target to HTMLElement
        const targetElement = event.target as HTMLElement;
        if (!targetElement) return;
        
        // Create new tooltip
        const tooltip = document.createElement('div');
        tooltip.className = 'custom-hover-tooltip';
        tooltip.textContent = 'Open in New Tab';
        document.body.appendChild(tooltip);
        
        // Position the tooltip above the icon
        const rect = targetElement.getBoundingClientRect();
        tooltip.style.top = (rect.top - tooltip.offsetHeight - 5) + 'px';
        tooltip.style.left = (rect.left + rect.width / 2) + 'px';
        tooltip.style.transform = 'translateX(-50%)';
      });
      
      newIcon.addEventListener('mouseleave', () => {
        removeTooltip();
      });
    });
  }
  
  protected options: any = {
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,
      type: 'pie',
      backgroundColor: '#FCFCFC',
      events: {
        render() {
          if (this.options && this.options.ngComponent) {
            this.options.ngComponent.initializeLegendHoverEffects();
          }
        },
        redraw(e) {
          if (this.isRedrawInProgress) return;
          this.isRedrawInProgress = true;

          if (this.options && this.options?.ngComponent) {
            this.options.ngComponent.enableLegendToggle(this, true);
            this.options.ngComponent.initializeLegendHoverEffects();
          }
        }
      }
    },
    isRedrawInProgress: false,
    colors: ['#D55FFF', '#EC4899', '#5C58C5', '#0BA1F6', '#15AB9B', '#F59E0B', '#F2CC00', '#6CC058', '#15AB9B', '#E394FF', '#FE98DB', '#9592F7',
       '#2ECDFF', '#64DCCF', '#FFC461', '#FEED92', '#9EEB8B', '#B316EB', '#EE0D7C', '#3D4376', '#0076B8', '#3EF4E1', '#2B9515','#293DE2'],
    title: {
      useHTML: true,
      text: '<span style="line-height: 21.79px;font-size: 16px;font-family: \'OpenSansBold\';color:\'#272727\'">Open Inquiries By Group</span>',
      align: 'left'
    },
    tooltip: {
      headerFormat: '<div style="font-size:12px;font-family: \'OpenSansSemiBold\';">{point.key}</div><table>',
      pointFormat: '<tr><td style="color: #272727;padding:0;font-family: \'OpenSans\';">{series.name} &nbsp&nbsp&nbsp </td> '
        + '<td style="padding:0;font-family: \'OpenSansBold\';"><b>{point.y:.0f}</b></td></tr>',
      footerFormat: '</table>',
      shared: false,
      backgroundColor: 'rgba(252,252, 252,1)',
      useHTML: true,
      outside: true,
      positioner: (w, h, pt) => {
        // C153176-4175: make sure the tooltip doesn't overlap with legend (left to the pie chart)
        let point = {
          x: Math.min(pt.plotX, Math.max(0, (0.6 * this.groupChart.chartWidth - w - window.scrollX))),
          y: Math.max(0, Math.min(this.groupChart.chartHeight, pt.plotY + 2 * h - window.scrollY))
        };
        return point;
      }
    },
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: false
        },
        showInLegend: true
      }
    },
    legend: {
      align: 'right',
      layout: 'vertical',
      verticalAlign: 'top',
      y: 0, //for C153176-5689
      width: '48%',
      itemMarginTop: 16,
      symbolRadius: 0,
      symbolPadding: 0,
      symbolWidth: 0.1,
      symbolHeight: 0.1,
      labelFormatter: function() {
        let name = this.name;
        const isFirstItem = this.index === 0;
        
        // Truncate long names
        if (window.innerWidth >= 767) {
          name = name.length > 35 ? name.slice(0, 33) + '...' : name;
        }
        
        const count = this.y;
        const percent = Highcharts.numberFormat(this.percentage, 2) + '%';
        const value = this.name + ' : ' + count + ' : ' + percent;
      
        const chartWidth = this.series.chart.chartWidth;
        const legendWidth = 0.45 * chartWidth;
        const nMinWidth = Math.min(300, Math.max(140, Math.floor(0.55 * legendWidth)));
        const cMinWidth = Math.min(55, Math.max(40, Math.floor(0.20 * legendWidth)));
        const pMinWidth = Math.min(60, Math.max(40, Math.floor(0.20 * legendWidth)));
      
        // Headings and Divider for the first item
        const headings = isFirstItem
          ? `
          <div style="display: flex; align-items: center; padding-bottom: 8px; padding-top: 18px; margin-bottom: 8px; border-bottom: 1px solid #D3D3D3;">
            <span class="custom-marker" style="border-color:white;background-color:white;display:inline-block;"></span>
            <span style="min-width:${nMinWidth}px;max-width:${nMinWidth}px;display:inline-block;line-height: 20px;font-size: 14px;font-family: 'OpenSans';color:'#272727'">Client Group</span>
            <span style="min-width:${cMinWidth}px;display:inline-block;text-align:center;line-height: 20px;font-size: 14px;font-family: 'OpenSans';color:'#272727'">Value</span>
            <span style="min-width:${pMinWidth}px;display:inline-block;text-align:right;line-height: 20px;font-size: 14px;font-family: 'OpenSans';color:'#272727'">%</span>
          </div>
          `
          : '';
      
        // Legend item content with hover icon - note the higher z-index values
        const legendItem = `
          <div class="legendLabel" title="${value}" data-id="${this.index}" data-name="${this.name}" data-color="${this.color}" data-count="${this.y}" style="display: flex; align-items: center;   margin-bottom:0; position: relative; z-index: 1;">
            <span class="custom-marker" style="border-color:${this.color};background-color:${this.color};display:inline-block;"></span>
            <span class="legend-name-container" style="position:relative; min-width:${nMinWidth}px;max-width:${nMinWidth}px;display:inline-block;line-height: 20px;font-size: 14px;font-family: 'OpenSans';color:'#272727'">
              ${name}
              <span class="hover-icon" style="display:none; position:absolute; margin-left:5px; margin-top: -2px; cursor:pointer; z-index: 10;">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="legend-icon" data-index="${this.index}" data-name="${this.name}" data-color="${this.color}" data-count="${this.y}">
                  <path d="M3.27525 13H9.6003C10.8653 13 11.8843 11.981 11.8843 10.716V6.85065C11.8843 6.55197 11.6559 6.32357 11.3573 6.32357C11.0586 6.32357 10.8302 6.55197 10.8302 6.85065V10.716C10.8302 11.4012 10.2855 11.9458 9.6003 11.9458H3.27525C2.59004 11.9458 2.04538 11.4012 2.04538 10.716V4.39092C2.04538 3.7057 2.59004 3.16105 3.27525 3.16105H7.14056C7.43924 3.16105 7.66764 2.93264 7.66764 2.63396C7.66764 2.33528 7.43924 2.10687 7.14056 2.10687H3.27525C2.01025 2.10687 0.991211 3.12591 0.991211 4.39092V10.716C0.991211 11.981 2.01025 13 3.27525 13Z" fill="#0066CC"/>
                  <path d="M13.0089 4.75989V1.54466C13.0089 1.50952 13.0089 1.47438 12.9913 1.43924C12.9913 1.42167 12.9913 1.4041 12.9738 1.4041C12.9738 1.38653 12.9562 1.36896 12.9562 1.35139C12.9562 1.33382 12.9386 1.31625 12.921 1.29868C12.921 1.28111 12.9035 1.26354 12.9035 1.26354C12.8683 1.21083 12.8156 1.15813 12.7629 1.12299L12.7278 1.10542C12.6926 1.05271 12.6575 1.03514 12.6224 1.03514L12.5697 1.01757C12.5345 1.01757 12.4994 1 12.4642 1H9.24901C8.95033 1 8.72192 1.2284 8.72192 1.52709C8.72192 1.82577 8.95033 2.05417 9.24901 2.05417H11.1992L6.3676 6.90337C6.15677 7.11421 6.15677 7.44803 6.3676 7.64129C6.57844 7.85213 6.91226 7.85213 7.10552 7.64129L11.9547 2.80966V4.75989C11.9547 5.05857 12.1831 5.28697 12.4818 5.28697C12.7629 5.28697 12.9913 5.041 13.0089 4.75989Z" fill="#0066CC"/>
                  <path d="M3.27525 13H9.6003C10.8653 13 11.8843 11.981 11.8843 10.716V6.85065C11.8843 6.55197 11.6559 6.32357 11.3573 6.32357C11.0586 6.32357 10.8302 6.55197 10.8302 6.85065V10.716C10.8302 11.4012 10.2855 11.9458 9.6003 11.9458H3.27525C2.59004 11.9458 2.04538 11.4012 2.04538 10.716V4.39092C2.04538 3.7057 2.59004 3.16105 3.27525 3.16105H7.14056C7.43924 3.16105 7.66764 2.93264 7.66764 2.63396C7.66764 2.33528 7.43924 2.10687 7.14056 2.10687H3.27525C2.01025 2.10687 0.991211 3.12591 0.991211 4.39092V10.716C0.991211 11.981 2.01025 13 3.27525 13Z" stroke="white" stroke-width="0.5"/>
                  <path d="M13.0089 4.75989V1.54466C13.0089 1.50952 13.0089 1.47438 12.9913 1.43924C12.9913 1.42167 12.9913 1.4041 12.9738 1.4041C12.9738 1.38653 12.9562 1.36896 12.9562 1.35139C12.9562 1.33382 12.9386 1.31625 12.921 1.29868C12.921 1.28111 12.9035 1.26354 12.9035 1.26354C12.8683 1.21083 12.8156 1.15813 12.7629 1.12299L12.7278 1.10542C12.6926 1.05271 12.6575 1.03514 12.6224 1.03514L12.5697 1.01757C12.5345 1.01757 12.4994 1 12.4642 1H9.24901C8.95033 1 8.72192 1.2284 8.72192 1.52709C8.72192 1.82577 8.95033 2.05417 9.24901 2.05417H11.1992L6.3676 6.90337C6.15677 7.11421 6.15677 7.44803 6.3676 7.64129C6.57844 7.85213 6.91226 7.85213 7.10552 7.64129L11.9547 2.80966V4.75989C11.9547 5.05857 12.1831 5.28697 12.4818 5.28697C12.7629 5.28697 12.9913 5.041 13.0089 4.75989Z" stroke="white" stroke-width="0.5"/>
                </svg>
              </span>
            </span>
            <span style="min-width:${cMinWidth}px;display:inline-block;text-align:center;line-height: 20px;font-size: 14px;font-family: 'OpenSans';color:'#272727'">${count ? count.toLocaleString() : count}</span>
            <span style="min-width:${pMinWidth}px;display:inline-block;text-align:right;line-height: 20px;font-size: 14px;font-family: 'OpenSans';color:'#272727'">${percent}</span>
          </div>
        `;
      
        return headings + legendItem;
      },
      useHTML: true,
      events: {
        itemClick: function(e) {
           const chartOptions = this.chart.options;
          
          if (chartOptions && chartOptions.ngComponent) {
            chartOptions.ngComponent.handleDoubleClick(
              e.legendItem.name,  // name
              e.legendItem.color, // color
              e.legendItem.y      // count
            );
            this.tabDataService.sendTabData(e.legendItem.name,e.legendItem.y )
          }
          return true; // Allow the default behavior
        }
      }

    },
    series: [{
      name: 'Inquiries',
      colorByPoint: true,
      allowPointSelect: true,
      point: {
        events: {
          dblclick: (event) => this.doubleclick(event),
          click: (event) => this.click(event),
          mouseOver() { this.slice(true); },
          mouseOut() { this.slice(false); }
        }
      },
      states: {
        hover: {
          halo: {
            opacity: 0
          }
        },
        inactive: {
          opacity: 1
        }
      },
      data: []
    }],
    navigation: {
      buttonOptions: {
        enabled: true,
        symbolSize: 25,
        symbolX: 25,
        symbolY: 24,
        theme: {
          r: 4,
        }
      }
    },
    exporting: {
      enabled: true,
      allowHTML: true,
      // C153176-4479: support larger print max width
      printMaxWidth: 1500,
      menuItemDefinitions: {
        maximize: {
          onclick() {
            if (this.options && this.options.ngComponent) {
              this.options.ngComponent.enterFullScreen(this);
            } else {
              console.log('assigned-group: Failed to enter full screen');
            }
          },
          text: 'Maximize'
        }
      },
      buttons: {
        contextButton: {
          menuItems: [{
            textKey: 'printChart',
            onclick() {
              this.print();
            }
          }, {
            textKey: 'downloadPNG',
            onclick: () => { this.localService.download("inquiry-by-group", "png"); }
          }, {
            textKey: 'downloadJPEG',
            onclick: () => { this.localService.download("inquiry-by-group", "jpg"); }
          }, {
            textKey: 'downloadPDF',
            onclick: () => { this.localService.download("inquiry-by-group", "pdf"); }
          }, {
            textKey: 'downloadCSV',
            onclick() {
              this.downloadCSV();
            }
          }, "maximize"], // "viewFullscreen"],
          symbol: 'url(assets/dashboard/context-menu.png)'
        }
      },
      csv: {
        decimalPoint: ":"
      }
    },
    credits: {
      enabled: false
    },
    ngComponent: null
  };
  protected groupChart: any;
  protected drilldownChart: any;
  protected dblclickCount = 0;
  openInquirychartSeries;
  legendExpanded: boolean = false; // C153176-4981: legend display mode

  click(event) {
    setTimeout(() => {
      if (!this.dblclickCount) {
        this.selectedGroup = event.point.name;
        this.localService.setSelectedGroupName(event.point.name);
        this.showByGroupAge(event.point.name);
        PiwikProUtils.trackJsonDataForEvent(this.userDataService.loggedInUserInfo.pivotProConfigEnabled, this.userDataService.loggedInUserInfo.userId, "Dashboard", "Open Inquiries By Group", "Click", "Open Inquiries By Group", 1);
      }
      this.dblclickCount--;
      this.dblclickCount = Math.max(0, this.dblclickCount);
    }, 200);
  }

  doubleclick(event) {
    this.dblclickCount = 2;
    setTimeout(() => {
      this.handleDoubleClick(event.point.name, event.point.color, event.point.y);
    }, 1000);
  }

  mobileAndTabletcheck = function () {
    var check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true; })(navigator.userAgent || navigator.vendor);
    return check;
  };

  ngOnInit() {
    try {
      if (this.iData) {
        if (Object.keys(this.iData).length !== 0) {
          this.resetByAgeGroup();
          const elem = $('#inquiry-by-group');
          if (elem && elem.length) {

            if (this.groupChart && typeof this.groupChart.destroy === 'function') {
              try {
                // Check if chart is still valid
                if (this.groupChart.renderTo && this.groupChart.container) {
                  this.groupChart.destroy();
                } else {
                  // If chart is invalid, just set it to null without destroying
                  this.groupChart = null;
                }
              } catch (e) {
                console.warn('Error while destroying request type chart', e);
                // Ensure requestTypeChart is nullified even if destroy fails
                this.groupChart = null;
              }
            }
            this.groupData = this.iData;
            this.handleData(this.iData);
            // Set Highcharts options
            Highcharts.setOptions({ lang: { thousandsSep: "," } });
            this.resetOptions();
            this.groupChart = Highcharts.chart('inquiry-by-group', this.options);
            this.groupChart.options.ngComponent = this;
            this.setupEventHandler();
            this.enableLegendToggle(this.groupChart, false);
          }
        }
      }
    } catch (e) {
        console.log(e);
      }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['iData']) {
      this.ngOnInit()
    }
  }

  resetOptions() {
    this.options.series[0].point.events = {
      dblclick: (event) => this.doubleclick(event),
      click: (event) => this.click(event),
      mouseOver() { this.slice(true); },
      mouseOut() { this.slice(false); },
      legendItemClick() { /* C153176-5538 */
        let s = this.series.points,
          index = this.index;
        let isHidden = s.some((obj) => !obj.visible);

        if (isHidden) {
          s[index].setVisible(!s[index].visible);
          if (s.every(obj => !obj.visible)) { //C153176-5756:Show all when none selected
            for (let i = 0; i < s.length; i++) {
              s[i].setVisible(true);
            }
          }
          return false
        }

        for (let i = 0; i < s.length; i++) {
          s[i].setVisible(i == index);
        }
        return false;
      }
    };
  }

  setupEventHandler() {
    if (this.groupChart) {
      this.groupChart.series.forEach((series) => {
        if (series && series.points) {
          series.points.forEach((p) => {
            if (p && p.graphic) {
              const point = p;
              p.graphic.on('dblclick', (event) => {
                if (point && point.series && point.series.chart && point.series.chart.options
                  && point.series.chart.options.ngComponent) {
                  this.dblclickCount = 2;
                  setTimeout(() => {
                    point.series.chart.options.ngComponent.handleDoubleClick(point.name, point.color, point.y);
                  }, 1200)
                }
              });
            }
          });
        }
      });
    }
  }

  handleData(chartNode) {
    // extracting and preparing series for Pie chart
    chartNode = chartNode.openInquiryByGroup[this.category];

    const tempSeries = new Array();
    let data;

    chartNode.map((ele, i) => {
      data = {};
      data.name = ele.group;
      data.y = ele.count;

      tempSeries.push(data);
    });
    tempSeries.sort((a, b) => (a.group > b.group) ? 1 : -1);
    this.options.series[0].data = tempSeries;
    this.cacheGroupColor(tempSeries);
  }

  cacheGroupColor(series) {
    if (this.parentComponent) {
      if (series) {
        let index = 0;
        const me = this;
        series.forEach((s) => {
          const group = s.name;
          const color = me.options.colors[index];
          this.parentComponent.addGroupColor(group, color);
          index++;
        });
      }
    } else {
      console.log("Cannot identify parent component from group chart!");
    }
  }

  showByGroupAge(groupName: string) {
    this.showbyAge = false;

    if (groupName !== "") {
      const drilledChartData = this.groupData.openInquiryByGroup[this.category].find((e) => {
        if (e.group === groupName) { return true; }
      });
      const tempObj = Object.assign({}, this.options);
      let data;
      const tempSeries = [];

      drilledChartData.inquiryByGroup.map((ele, i) => {
        data = {};
        data.name = ele.age;
        data.y = ele.count;
        tempSeries.push(data);
      });
      tempObj.title.x = 24;
      tempObj.subtitle = {
        useHTML: true,
        text: '<span class="innerLabel" style="font-weight:bold;">' //C153176-5687 open inquiry by chart - Group name is not aligned properly
          + $('<div>').text(this.selectedGroup).html() + '</span>',
        align: 'left',
        verticalAlign: 'top',
        x: 280,
      };
      tempObj.series[0].data = tempSeries;
      tempObj.series[0].point.events.click = "";
      // removing events for drill down chart
      tempObj.series[0].events = {};
      tempObj.exporting.buttons = {
        contextButton: {
          menuItems: [{
            textKey: 'printChart',
            onclick() {
              this.print();
            }
          }, {
            textKey: 'downloadPNG',
            onclick: () => { this.localService.download("inquiry-by-group-age", "png"); }
          }, {
            textKey: 'downloadJPEG',
            onclick: () => { this.localService.download("inquiry-by-group-age", "jpg"); }
          }, {
            textKey: 'downloadPDF',
            onclick: () => { this.localService.download("inquiry-by-group-age", "pdf"); }
          }, {
            textKey: 'downloadCSV',
            onclick() {
              this.downloadCSV();
            }
          }, "maximize"], // "viewFullscreen"],
          symbol: 'url(assets/dashboard/context-menu.png)'
        }
      };

      const tempArr = [];
      Array.prototype.push.apply(tempArr, this.options.colors);
      tempObj.colors = tempArr.reverse();
      const elem = $('#inquiry-by-group-age');
      if (elem && elem.length) {
        if (this.drilldownChart) {
          this.drilldownChart.destroy();
        }
        this.drilldownChart = Highcharts.chart('inquiry-by-group-age', tempObj);
        const component = this;
        this.drilldownChart.renderer.image("./assets/qwyn/icons/left-arrow.svg", 15, 12, 12, 12).attr({
          zIndex: 3
        }).on('click', () => {
          component.hideByAge();
        }).add();
      }
    }
  }

  hideByAge() {
    this.DS.getInquiriesTrendCnts();
    this.resetByAgeGroup();
    // C153176-4981: show/hide expand/collapse button
    if (this.groupChart && this.groupChart.legend && this.groupChart.legend.display) {
      $("#legend-expand-button").show();
    } else {
      $("#legend-expand-button").hide();
    }
  }

  resetByAgeGroup() {
    this.showbyAge = true;
    this.selectedGroup = "";
    this.localService.setSelectedGroupName(this.selectedGroup);
  }

  handleDoubleClick(group, color, count) {
    this.requestMessageView(group, color, count);
    PiwikProUtils.trackJsonDataForEvent(this.userDataService.loggedInUserInfo.pivotProConfigEnabled, this.userDataService.loggedInUserInfo.userId, "Dashboard", "Open Inquiries By Group Pie Chart", "DoubleClick", "Open Inquiries By Group Pie Chart", 1);
  }

  requestMessageView(group, color, count) {
    this.inboxService.startViewLoading({ color });
    // C153176-4447: request with 'groupId' and 'isReqFromQma2Dashboard'
    const groupId = this.userDataService && this.userDataService.allActiveGroupIds ? this.userDataService.allActiveGroupIds[group] : undefined;
    this.inboxService.requestView({
      viewName: "Open Inquiries By Assigned Group", count, type: "assignedGroupName", value: group,
      groupId: groupId, isReqFromQma2Dashboard: true
    });
  }

  // handle ESC in case of full screen
  @HostListener('document:keydown.esc', ['$event'])
  onKeydown(event) {
    event.stopPropagation();
    event.preventDefault();
    if (this.fullScreen && event && event.code === 'Escape') {
      if ($("#inquiries-by-group-box .drillDownCard").attr("hidden")) { // main chart exit
        this.exitFullScreen(this.groupChart);
      } else { // chart drill down
        this.exitFullScreen(this.drilldownChart);
      }
    }
  }

  enterFullScreen(chart: any) {
    const elem = $('#assigned-group-box');
    if (elem && elem.length) {
      elem.toggleClass('col-sm-6');
      elem.toggleClass('col-sm-12');
      elem.toggleClass('dashboardModal');
    }
    this.fullScreen = true;
    if (chart.exportContextMenu && chart.exportContextMenu.childNodes) {
      chart.exportContextMenu.childNodes.forEach(node => {
        if (node && node.childNodes) {
          node.childNodes.forEach(n => {
            if (n && n.innerText === 'Maximize') {
              n.style.display = 'none';
            }
          });
        }
      });
    }
    chart.reflow();
    if (this.fadingDialogComponent) {
      this.fadingDialogComponent.show($('#inquiries-by-group-box')[0]);
    }
  }

  exitFullScreen(chart: any) {
    if (!chart) {
      return;
    }
    const elem = $('#assigned-group-box');
    if (elem && elem.length) {
      elem.toggleClass('col-sm-6');
      elem.toggleClass('col-sm-12');
      elem.toggleClass('dashboardModal');
    }
    this.fullScreen = false;
    if (this.fadingDialogComponent) {
      this.fadingDialogComponent.hide($('#inquiries-by-group-box')[0]);
    }
    if (chart.exportContextMenu && chart.exportContextMenu.childNodes) {
      chart.exportContextMenu.childNodes.forEach(node => {
        if (node && node.childNodes) {
          node.childNodes.forEach(n => {
            if (n && n.innerText === 'Maximize') {
              n.style.display = '';
            }
          });
        }
      });
    }
    chart.reflow();
  }

  enableLegendToggle(chart, resize) {
    if (!chart) {
      return;
    }
    if (this.chartWidth === undefined || chart.chartWidth !== this.chartWidth || chart.chartHeight !== this.chartHeight) {
      this.chartWidth = chart.chartWidth;
      this.chartHeight = chart.chartHeight;
    } else if (resize) {
      // request due to resize, but size hasn't changed, do nothing
      return;
    }
    if (!resize && chart.toggleButton && chart.toggleLabel) {
      // if not resizing but chart already has a toggle button, do nothing
      return;
    }
    // re-create the toggle label and button
    if (chart.toggleButton) {
      chart.toggleButton.destroy();
      chart.toggleButton = null;
    }
    if (chart.toggleLabel) {
      chart.toggleLabel.destroy();
      chart.toggleLabel = null;
    }
    const lWidth = Math.max(0, Math.floor(this.chartWidth - 160));
    chart.toggleLabel = chart.renderer.text(
      '<span class="mobileView" style="font-size:13px;font-family:\'OpenSansLight\';text-align:right;min-width:90px;">HIDE LEGEND</span>',
      lWidth,
      20,
      true).css({
        textAlign: 'right',
        minWidth: '90px'
      }).add();
    const bbox = chart.toggleLabel.getBBox();
    chart.toggleButton = chart.renderer.label('<label class="switch-rt"><input id="group-chart-toggle"'
      + ' type="checkbox" checked><span class="slider-rt round-rt"></span></label>',
      lWidth + bbox.width + 5,
      5,
      'button',
      null,
      null,
      true).on('change', (e) => {
        //
        // do nothing here
      }).add();
    // C153176-4981: add expand/collapse button
    if (window.innerWidth < 767) {
      chart.legendExpandButton = chart.renderer.label(
        '<label style="font-size:16px;font-family:\'OpenSansLight\';text-align:right;min-width:15px;">'
        + '<span class="fa fa-caret-down" id="legend-expand-button"></span></label>',
        lWidth + bbox.width + 30,
        25,
        'button',
        null, null, true).add();
    }
    setTimeout(() => {
      const elem = $("#group-chart-toggle");
      // @ts-ignore
      elem.val(true);
      if (elem && elem.length) {
        elem.change(e => {
          const val = !$('#group-chart-toggle').val();
          // @ts-ignore
          $('#group-chart-toggle').val(val);
          if (this.groupChart) {
            this.toggleLegend(this.groupChart);
          }
        });
      }
    }, 100);
    setTimeout(() => {
      if (window.innerWidth < 767) {
        $("#group-chart-toggle").prop('checked', false);
        this.hideLegend(this.groupChart);
      }
    }, 200);
    // C153176-4981: handle legend toggling
    setTimeout(() => {
      if (window.innerWidth < 767) {
        $("#legend-expand-button").click((e) => {
          if (!this.legendExpanded) {
            $('.legendLabel').removeClass('legendLabel').addClass('legendExpandLabel');
            $("#legend-expand-button").removeClass('fa-caret-down').addClass('fa-caret-up');
            let parent = $('#inquiry-by-group .highcharts-container .highcharts-legend .highcharts-legend-item > span');
            if (parent && parent.length) {
              parent.css('height', 'fit-content !important');
              let top = 19;
              parent.each((index, elem) => {
                $(elem).css('top', '' + top + 'px');
                top += 28;
              })
            }
          } else {
            $('.legendExpandLabel').removeClass('legendExpandLabel').addClass('legendLabel');
            $("#legend-expand-button").removeClass('fa-caret-up').addClass('fa-caret-down');
            let parent = $('#inquiry-by-group .highcharts-container .highcharts-legend .highcharts-legend-item > span');
            if (parent && parent.length) {
              parent.css('height', 'unset');
              let top = 19;
              parent.each((index, elem) => {
                $(elem).css('top', '' + top + 'px');
              })
            }
          }
          this.legendExpanded = !this.legendExpanded;
        });
      }
    }, 200);

  }
  toggleLegend(chart) {
    if (!chart) {
      return;
    }
    const legend = chart.legend;
    let text;
    let html;
    if (legend.display) {
      chart.legend.update({
        enabled: false
      });
      chart.update({
        marginRight: 22
      });
      legend.display = false;
      text = 'SHOW LEGEND';
      html = '<span class="mobileView" style="font-size:13px;font-family:\'OpenSansLight\';text-align:right;min-width:90px;">SHOW LEGEND</span>';
      $("#legend-expand-button").hide(); // C153176-4981: show expand/collapse toggle
    } else {
      chart.legend.update({
        enabled: true
      });
      chart.update({
        marginRight: undefined
      });
      legend.display = true;
      text = 'HIDE LEGEND';
      html = '<span class="mobileView" style="font-size:13px;font-family:\'OpenSansLight\';text-align:right;min-width:90px;">HIDE LEGEND</span>';
      $("#legend-expand-button").show(); // C153176-4981: show expand/collapse toggle
    }
    if (chart.toggleLabel && chart.toggleLabel.element) {
      chart.toggleLabel.element.textContext = text;
      chart.toggleLabel.element.innerText = text;
      chart.toggleLabel.element.innerHTML = html;
    }
    chart.redraw();
  }
  hideLegend(chart) {
    if (!chart) {
      return;
    }
    const legend = chart.legend;
    let text;
    let html;
    chart.legend.update({
      enabled: false
    });
    chart.update({
      marginRight: 22
    });
    legend.display = false;
    text = 'SHOW LEGEND';
    html = '<span class="mobileView" style="font-size:13px;font-family:\'OpenSansLight\';text-align:right;min-width:90px;">SHOW LEGEND</span>';

    chart.toggleLabel.element.textContext = text;
    chart.toggleLabel.element.innerText = text;
    chart.toggleLabel.element.innerHTML = html;

    chart.redraw();
    $("#legend-expand-button").hide();// C153176-4981: hide expand/collapse toggle
  }
  showLegend(chart) {
    if (!chart) {
      return;
    }
    const legend = chart.legend;
    let text;
    let html;
    chart.legend.update({
      enabled: true
    });
    chart.update({
      marginRight: undefined
    });
    legend.display = true;
    text = 'HIDE LEGEND';
    html = '<span class="mobileView" style="font-size:13px;font-family:\'OpenSansLight\';text-align:right;min-width:90px;">HIDE LEGEND</span>';
    chart.toggleLabel.element.textContext = text;
    chart.toggleLabel.element.innerText = text;
    chart.toggleLabel.element.innerHTML = html;

    chart.redraw();
    $("#legend-expand-button").show(); // C153176-4981: show expand/collapse toggle
  }
  onResize(event) {
    if (event.target.innerWidth < 767) // window width
    {
      this.hideLegend(this.groupChart);
    } else {
      this.showLegend(this.groupChart);
    }
  }
}
